import TtamExistingAdGroup from './exising-ad-group/index.vue';
import * as hooks from './hooks';

export default {
  TtamExistingAdGroup,
  ...hooks,
};
